import { useLanguageStore } from '../stores/languageStore';
import en from './en.json';
import af from './af.json';
const translations = { en, af };
/**
 * Resolve a dotted i18n key. When `params` are supplied, `{name}` placeholders
 * in the resolved string are substituted with the corresponding values — e.g.
 * t('consent.roster.summary', { signed: 2, total: 3 }) → "2 of 3 signed".
 * Placeholders that have no matching param are left in-place so they're visible
 * rather than silently disappearing.
 */
export function useTranslation() {
    const { language, setLanguage } = useLanguageStore();
    function t(key, params) {
        const keys = key.split('.');
        let value = translations[language];
        for (const k of keys) {
            value = value?.[k];
        }
        if (typeof value !== 'string')
            return key;
        if (!params)
            return value;
        return value.replace(/\{(\w+)\}/g, (match, name) => params[name] !== undefined ? String(params[name]) : match);
    }
    return { t, language, setLanguage };
}
